// React
import { createContext } from 'react';

// Listing Context
export const ListingContext = createContext({});
